import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorFeeDiscountMaker = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="m20.25.75.06.364a2.77 2.77 0 0 0 2.19 2.261 2.77 2.77 0 0 0-2.19 2.261L20.25 6l-.058-.348A2.798 2.798 0 0 0 18 3.375a2.77 2.77 0 0 0 2.19-2.261l.06-.364Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="m21.75 6 .008.06c.049.378.36.668.742.69l-.029.005a.895.895 0 0 0-.721.745.834.834 0 0 0-.682-.738L21 6.75a.79.79 0 0 0 .747-.717L21.75 6Z"
    />
    <path
      fill="#F7A600"
      d="M9.975 11.15c-.435 0-.806-.154-1.113-.461A1.518 1.518 0 0 1 8.4 9.575c0-.435.154-.806.462-1.114A1.518 1.518 0 0 1 9.975 8c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.517 1.517 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm4.05 4.95c-.435 0-.806-.154-1.113-.461a1.518 1.518 0 0 1-.462-1.114c0-.435.154-.806.462-1.114a1.518 1.518 0 0 1 1.113-.461c.435 0 .807.154 1.114.461.308.308.461.679.461 1.114 0 .435-.153.806-.46 1.114a1.517 1.517 0 0 1-1.115.461Zm0-.9a.65.65 0 0 0 .478-.197.65.65 0 0 0 .197-.478.65.65 0 0 0-.197-.478.65.65 0 0 0-.478-.197.65.65 0 0 0-.478.197.65.65 0 0 0-.197.478.65.65 0 0 0 .197.478.65.65 0 0 0 .478.197Zm-4.995.9-.63-.63L14.97 8l.63.63-6.57 6.57Z"
    />
    <path
      fill="#F7A600"
      fillRule="evenodd"
      d="M13.644 20.531c-.264.288-.754.824-1.644.824-.378 0-.705-.062-.991-.218-.279-.152-.45-.36-.548-.478l-.002-.003a1.164 1.164 0 0 0-.207-.22c-.052-.038-.155-.099-.38-.146-.287-.06-.497.022-.904.332-.055.043-.116.09-.181.143-.37.296-.903.722-1.585.912-.823.23-1.585-.125-2.1-.482a5.295 5.295 0 0 1-1.212-1.203.75.75 0 0 1 1.22-.872c.17.238.487.591.85.844.382.266.662.318.838.269.365-.102.626-.307.993-.596.083-.064.171-.134.267-.207.482-.368 1.16-.81 2.122-.608.4.084.708.22.959.404.22.161.37.344.456.45l.022.026a.51.51 0 0 0 .11.117s.059.036.273.036c.218 0 .283-.067.613-.42.146-.155.383-.401.725-.55.374-.163.785-.176 1.233-.051.76.212 1.305.633 1.691.931l.036.027c.451.348.588.413.702.413.06 0 .175-.021.356-.103.175-.079.37-.195.577-.336.208-.14.41-.293.607-.442l.02-.014c.18-.136.374-.284.54-.388a.75.75 0 1 1 .8 1.269c-.106.066-.25.175-.456.33l-.005.004a15.93 15.93 0 0 1-.664.483 5.483 5.483 0 0 1-.802.461c-.28.126-.616.236-.973.236-.682 0-1.216-.413-1.562-.682-.02-.014-.037-.028-.055-.042-.406-.313-.75-.572-1.217-.703-.17-.047-.223-.021-.228-.018-.035.015-.09.053-.232.203-.02.02-.04.044-.062.068Z"
      clipRule="evenodd"
    />
    <path
      fill={getTheme(props["data-theme"])}
      fillRule="evenodd"
      d="M12 4.75a7.25 7.25 0 0 0-4.795 12.688.75.75 0 1 1-.993 1.124 8.75 8.75 0 1 1 11.576 0 .75.75 0 1 1-.993-1.124A7.25 7.25 0 0 0 12 4.75Z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgTwoColorFeeDiscountMaker;
